import { apiClient } from '@/services/apiClient';

export type LandingPageNotForYouFeedbackPayload = {
    reason: string;
    discovery_source: string | null;
    feedback: string | null;
    email: string | null;
};

export type LandingPageNotForYouFeedbackResponse = {
    success: boolean;
};

export const landingPageNotForYouFeedbackService = {
    submit(payload: LandingPageNotForYouFeedbackPayload) {
        return apiClient.post<LandingPageNotForYouFeedbackResponse>('/landing-page-not-for-you-feedback', payload);
    },
};
